/* The ONAM footer: MAP's legal line and certifications, in ONAM's style. Same content as MAP's footer. */
import React from "react";
import CertinLogo from "../../assets/certin.svg";
import Soc2Badge from "../../assets/soc_img.webp";
import IsoBadge from "../../assets/iso.webp";
import "./chrome.css";

export default function OnamFooter() {
  return (
    <footer className="onam-app onam-chrome onam-foot">
      <span>Powered by <b>Atom</b> · Patented in the USA and Singapore · © {new Date().getFullYear()} Saptharushi Pte. Ltd. All rights reserved.</span>
      <span className="of-badges"><img src={CertinLogo} alt="CERT-In" className="certin" /><img src={Soc2Badge} alt="SOC 2 Type II" /><img src={IsoBadge} alt="ISO certified" /></span>
    </footer>
  );
}
